// 动态导入主题样式，确保单独打包
import(/* webpackChunkName: "theme-tg_green" */ "@/styles/themes/theme-tg_green.scss");
import(/* webpackChunkName: "theme-tg_blue" */ "@/styles/themes/theme-tg_blue.scss");

import "@/styles/index.scss";

//引入iconfont 字体图标库
import "@/assets/font/iconfont.css";

import "amfe-flexible";
import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"; // 持久化存储

import App from "./App.vue";
import router from "./router";
import GlobalHeader from "./components/globalHeader/index.vue";
import $sensors from "./utils/sensors";
import { initSentry } from "./utils/sentry";
import { h5Debug } from "./utils/bridge";
import { getAssetsFile } from "./utils/utils";
import { DynamicLibLoader } from "./utils/dynamicLoader";
import { initTheme } from "./theme";
import { createVersionPolling } from "version-polling";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// 初始化主题
initTheme();

const VueApp = createApp(App);

// 初始化 Sentry
initSentry(VueApp, router);

VueApp.use(router);
VueApp.use(pinia);
VueApp.use(GlobalHeader as any);

VueApp.config.globalProperties.$getAssetsFile = getAssetsFile;
VueApp.mount("#app");

// 调试模式开关 - 控制是否启用 VConsole 调试工具（从 CDN 加载，不打包）
if (import.meta.env.VITE_DEBUG_LOG === "true" || h5Debug()) {
  DynamicLibLoader.loadScript("/js/vconsole.min.js", "VConsole").then(() => {
    new (window as any).VConsole();
  });
}

$sensors.$initPerformance("首页");

// 全局错误监听：处理动态模块加载失败（通常发生在版本更新后）
createVersionPolling({
  silent: import.meta.env.DEV, // 开发环境下不检测
  vcType: "chunkHash",
  chunkName: "index",
  silentPollingInterval: true,
  onUpdate: (self) => {
    console.warn("检测到网页有更新, 刷新页面");
    self.onRefresh();
  },
});
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});
